module.exports = __webpack_public_path__ + "static/media/smartphone.bf9fcc33.png";